// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#container {
  width: 100vw;
  height: 100vh;
  height: 100svh;
}

#aic {
  width: 100vw;
}

.heading {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.register {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-bottom: 20px;
}

.signupParent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75vh;
}

.signupChild {
  padding: 30px;
  width: 80%;
  max-width: 500px;
  height: 90%;
  border-radius: 20px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.signupChild.inactive {
  display: none;
}

.passRequirements {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 99;
  border-radius: 20px;
  margin: 10px;
  margin-top: 4px;
  background-color: beige;
  padding: 15px;
  width: 215px;
  font-size: 13px;
  height: 45px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s;
}

.passRequirements.dropdown {
  height: auto;
}

.signupChild__error {
  color: red;
  height: 30px;
}

.signupChild h1 {
  margin-bottom: 10px;
  text-align: center;
}

.signupChild .inputField {
  margin: 5px 0px 15px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.signupChild label {
  margin-bottom: 5px;
}

.signupChild input {
  padding: 10px;
  border: solid #000 1px;
  border-radius: 10px;
  width: 250px;
  height: 36px;
}

.signupChild form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.signupChild__confirm,
.signupChild__confirm--php {
  width: 100px;
  height: 50px;
  border-radius: 20px;
  background-color: var(--main-deepColor);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  color: #000;
}

.signupChild__msg {
  margin-top: 10px;
}

.signupChild__msg a {
  text-decoration: none;
}

.signupSuccess {
  display: none;
}

.signupSuccess.active {
  display: flex;
}

.signupSuccess__logo {
  font-size: 70px;
  margin-bottom: 10px;
}

.signupSuccess__logo i {
  color: #41c34a;
  border: solid #41c34a 10px;
  border-radius: 50%;
  padding: 10px;
  width: 110px;
  height: 110px;
}

.signupSuccess__text {
  text-align: center;
}

.signupSuccess__btn {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.signupChild.result {
  display: none;
  overflow: auto;
  justify-content: normal;
  padding: 30px;
}

.signupChild.emailSent {
  display: none;
}

.signupChild.passwordResetSuccess {
  display: none;
}

.signupChild.result.active {
  display: flex;
}

.signupChild.emailSent.active {
  display: flex;
}

.signupChild.passwordResetSuccess.active {
  display: flex;
}

.aicBtn {
  padding: 10px;
  margin: 19px;
  border: none;
  border-radius: 10px;
  color: #000;
  cursor: pointer;
  background-color: #fff;
}

.aicBtn.migration {
  margin: 0px 10px 0px 0px;
}

#code404 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 60%;
}

#code404 img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

#code404 a {
  text-decoration: none;
  font-size: 20px;
}

#userData {
  width: -webkit-fill-available;
  margin: 20px;
  padding: 20px;
  border-radius: 20px;
  background-color: #f0f0f0;
  overflow-x: auto;
}

#userData table {
  width: 100%;
  border-spacing: 0px;
  border-collapse: separate;
  text-align: left;
}

#userData table tr:first-child {
  background-color: #040622;
  color: #fff;
  height: 60px;
}

#userData table tr > * {
  padding: 10px;
}

#userData button {
  border: none;
  background-color: #d73333;
  color: #fff;
  border-radius: 20px;
  padding: 10px;
  cursor: pointer;
}

.warning__parent {
  background-color: rgba(0, 0, 0, 0.168627451);
  width: 100vw;
  height: 100vh;
  height: 100svh;
  height: 100dvh;
  backdrop-filter: blur(6px);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 1;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.58, 1.4);
}

.warning__parent.active {
  opacity: 1;
  visibility: visible;
}

.warning__child {
  margin: 0px 10px;
  border-radius: 20px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.warning__child i {
  font-size: 45px;
  color: red;
  margin-bottom: 10px;
}

.warning__child .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
}

.warning__child .btn__ele {
  background-color: #f0f0f0;
  border-radius: 10px;
  padding: 15px;
  margin: 10px 10px 0px 10px;
}

.restore__msg {
  text-align: center;
  padding: 10px;
}

.btn__restore {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.btn__ele {
  background-color: var(--main-deepColor);
  border-radius: 20px;
  padding: 20px;
  margin: 20px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.search-area {
  margin: 20px 20px 0px 20px;
}

.search-area #search {
  border-radius: 20px;
  border: none;
  padding: 15px;
  width: 100%;
  max-width: 500px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  font-size: 15px;
}

.template-image-background {
  mask-image: linear-gradient(to bottom, transparent, black 25%, black 75%, transparent);
}

/* Web responsive */
@media screen and (max-width: 600px) {
  .card-slider .swiper-wrapper {
    scale: 0.7;
  }
  .signupParent {
    height: 68vh;
  }
  .signupChild {
    height: 100%;
  }
  .signupChild h1 {
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./controllers/client/css/main.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,cAAA;AACF;;AACA;EACE,YAAA;AAEF;;AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAGF;;AADA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAIF;;AAFA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAKF;;AAHA;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qDAAA;AAMF;;AAJA;EACE,aAAA;AAOF;;AALA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAQF;;AANA;EACE,YAAA;AASF;;AAPA;EACE,UAAA;EACA,YAAA;AAUF;;AARA;EACE,mBAAA;EACA,kBAAA;AAWF;;AATA;EACE,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAYF;;AAVA;EACE,kBAAA;AAaF;;AAXA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAcF;;AAZA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAeF;;AAbA;;EAEE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,uCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAgBF;;AAdA;EACE,gBAAA;AAiBF;;AAfA;EACE,qBAAA;AAkBF;;AAhBA;EACE,aAAA;AAmBF;;AAjBA;EACE,aAAA;AAoBF;;AAlBA;EACE,eAAA;EACA,mBAAA;AAqBF;;AAnBA;EACE,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AAsBF;;AApBA;EACE,kBAAA;AAuBF;;AArBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAwBF;;AAtBA;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;AAyBF;;AAvBA;EACE,aAAA;AA0BF;;AAxBA;EACE,aAAA;AA2BF;;AAzBA;EACE,aAAA;AA4BF;;AA1BA;EACE,aAAA;AA6BF;;AA3BA;EACE,aAAA;AA8BF;;AA5BA;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AA+BF;;AA7BA;EACE,wBAAA;AAgCF;;AA9BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;AAiCF;;AA/BA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAkCF;;AAhCA;EACE,qBAAA;EACA,eAAA;AAmCF;;AAjCA;EACE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAoCF;;AAlCA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAqCF;;AAnCA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;AAsCF;;AApCA;EACE,aAAA;AAuCF;;AArCA;EACE,YAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAwCF;;AAtCA;EACE,4CAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,oDAAA;AAyCF;;AAvCA;EACE,UAAA;EACA,mBAAA;AA0CF;;AAxCA;EACE,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,iDAAA;AA2CF;;AAzCA;EACE,eAAA;EACA,UAAA;EACA,mBAAA;AA4CF;;AA1CA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AA6CF;;AA3CA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;AA8CF;;AA3CA;EACE,kBAAA;EACA,aAAA;AA8CF;;AA5CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA+CF;;AA7CA;EACE,uCAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAgDF;;AA9CA;EACE,0BAAA;AAiDF;;AA/CA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,qDAAA;EACA,eAAA;AAkDF;;AA/CA;EACE,sFAAA;AAkDF;;AAhDA,mBAAA;AACA;EACE;IACE,UAAA;EAmDF;EAjDA;IACE,YAAA;EAmDF;EAjDA;IACE,YAAA;EAmDF;EAjDA;IACE,mBAAA;EAmDF;AACF","sourcesContent":["#container {\n  width: 100vw;\n  height: 100vh;\n  height: 100svh;\n}\n#aic {\n  width: 100vw;\n}\n.heading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.register {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  margin-bottom: 20px;\n}\n.signupParent {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 75vh;\n}\n.signupChild {\n  padding: 30px;\n  width: 80%;\n  max-width: 500px;\n  height: 90%;\n  border-radius: 20px;\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n.signupChild.inactive {\n  display: none;\n}\n.passRequirements {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 99;\n  border-radius: 20px;\n  margin: 10px;\n  margin-top: 4px;\n  background-color: beige;\n  padding: 15px;\n  width: 215px;\n  font-size: 13px;\n  height: 45px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.passRequirements.dropdown {\n  height: auto;\n}\n.signupChild__error {\n  color: red;\n  height: 30px;\n}\n.signupChild h1 {\n  margin-bottom: 10px;\n  text-align: center;\n}\n.signupChild .inputField {\n  margin: 5px 0px 15px 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.signupChild label {\n  margin-bottom: 5px;\n}\n.signupChild input {\n  padding: 10px;\n  border: solid #000 1px;\n  border-radius: 10px;\n  width: 250px;\n  height: 36px;\n}\n.signupChild form {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.signupChild__confirm,\n.signupChild__confirm--php {\n  width: 100px;\n  height: 50px;\n  border-radius: 20px;\n  background-color: var(--main-deepColor);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border: none;\n  color: #000;\n}\n.signupChild__msg {\n  margin-top: 10px;\n}\n.signupChild__msg a {\n  text-decoration: none;\n}\n.signupSuccess {\n  display: none;\n}\n.signupSuccess.active {\n  display: flex;\n}\n.signupSuccess__logo {\n  font-size: 70px;\n  margin-bottom: 10px;\n}\n.signupSuccess__logo i {\n  color: #41c34a;\n  border: solid #41c34a 10px;\n  border-radius: 50%;\n  padding: 10px;\n  width: 110px;\n  height: 110px;\n}\n.signupSuccess__text {\n  text-align: center;\n}\n.signupSuccess__btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n}\n.signupChild.result {\n  display: none;\n  overflow: auto;\n  justify-content: normal;\n  padding: 30px;\n}\n.signupChild.emailSent {\n  display: none;\n}\n.signupChild.passwordResetSuccess {\n  display: none;\n}\n.signupChild.result.active {\n  display: flex;\n}\n.signupChild.emailSent.active {\n  display: flex;\n}\n.signupChild.passwordResetSuccess.active {\n  display: flex;\n}\n.aicBtn {\n  padding: 10px;\n  margin: 19px;\n  border: none;\n  border-radius: 10px;\n  color: #000;\n  cursor: pointer;\n  background-color: #fff;\n}\n.aicBtn.migration {\n  margin: 0px 10px 0px 0px;\n}\n#code404 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  height: 60%;\n}\n#code404 img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n#code404 a {\n  text-decoration: none;\n  font-size: 20px;\n}\n#userData {\n  width: -webkit-fill-available;\n  margin: 20px;\n  padding: 20px;\n  border-radius: 20px;\n  background-color: #f0f0f0;\n  overflow-x: auto;\n}\n#userData table {\n  width: 100%;\n  border-spacing: 0px;\n  border-collapse: separate;\n  text-align: left;\n}\n#userData table tr:first-child {\n  background-color: #040622;\n  color: #fff;\n  height: 60px;\n}\n#userData table tr > * {\n  padding: 10px;\n}\n#userData button {\n  border: none;\n  background-color: #d73333;\n  color: #fff;\n  border-radius: 20px;\n  padding: 10px;\n  cursor: pointer;\n}\n.warning__parent {\n  background-color: #0000002b;\n  width: 100vw;\n  height: 100vh;\n  height: 100svh;\n  height: 100dvh;\n  backdrop-filter: blur(6px);\n  position: fixed;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.58, 1.4);\n}\n.warning__parent.active {\n  opacity: 1;\n  visibility: visible;\n}\n.warning__child {\n  margin: 0px 10px;\n  border-radius: 20px;\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 20px;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n}\n.warning__child i {\n  font-size: 45px;\n  color: red;\n  margin-bottom: 10px;\n}\n.warning__child .btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  cursor: pointer;\n}\n.warning__child .btn__ele {\n  background-color: #f0f0f0;\n  border-radius: 10px;\n  padding: 15px;\n  margin: 10px 10px 0px 10px;\n}\n\n.restore__msg {\n  text-align: center;\n  padding: 10px;\n}\n.btn__restore {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n.btn__ele {\n  background-color: var(--main-deepColor);\n  border-radius: 20px;\n  padding: 20px;\n  margin: 20px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n.search-area {\n  margin: 20px 20px 0px 20px;\n}\n.search-area #search {\n  border-radius: 20px;\n  border: none;\n  padding: 15px;\n  width: 100%;\n  max-width: 500px;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  font-size: 15px;\n}\n\n.template-image-background {\n  mask-image: linear-gradient(to bottom, transparent, black 25%, black 75%, transparent);\n}\n/* Web responsive */\n@media screen and (max-width: 600px) {\n  .card-slider .swiper-wrapper {\n    scale: 0.7;\n  }\n  .signupParent {\n    height: 68vh;\n  }\n  .signupChild {\n    height: 100%;\n  }\n  .signupChild h1 {\n    margin-bottom: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
